import { CkEditor } from './contants';

import CKEDITOR from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';

import { Alignment } from '@ckeditor/ckeditor5-alignment';  // Importing the package.
import { Autoformat } from '@ckeditor/ckeditor5-autoformat';
import { Bold, Code, Italic, Strikethrough, Subscript, Superscript, Underline } from '@ckeditor/ckeditor5-basic-styles';
import { BlockQuote } from '@ckeditor/ckeditor5-block-quote';
import { Essentials } from '@ckeditor/ckeditor5-essentials';
import { Heading } from '@ckeditor/ckeditor5-heading';
import { Font } from '@ckeditor/ckeditor5-font';
import { Highlight } from '@ckeditor/ckeditor5-highlight';
import {
    AutoImage,
    Image,
    ImageCaption,
    ImageInsert,
    ImageResize,
    ImageStyle,
    ImageToolbar,
    ImageUpload,
    PictureEditing
} from '@ckeditor/ckeditor5-image';
import { SimpleUploadAdapter } from '@ckeditor/ckeditor5-upload';
import { Indent } from '@ckeditor/ckeditor5-indent';
import { AutoLink, Link, LinkImage } from '@ckeditor/ckeditor5-link';
import { List } from '@ckeditor/ckeditor5-list';
import { HorizontalLine } from '@ckeditor/ckeditor5-horizontal-line';
import { MediaEmbed } from '@ckeditor/ckeditor5-media-embed';
// import { Paragraph } from '@ckeditor/ckeditor5-paragraph';
import { PasteFromOffice } from '@ckeditor/ckeditor5-paste-from-office';
import { Table, TableProperties, TableCellProperties, TableColumnResize, TableUtils, TableClipboard, TableSelection, TableToolbar } from '@ckeditor/ckeditor5-table';
import { TextTransformation } from '@ckeditor/ckeditor5-typing';
import { RemoveFormat } from '@ckeditor/ckeditor5-remove-format';
import { SpecialCharacters, SpecialCharactersEssentials } from '@ckeditor/ckeditor5-special-characters';
import { SourceEditing } from '@ckeditor/ckeditor5-source-editing';
import { GeneralHtmlSupport } from '@ckeditor/ckeditor5-html-support';
import { HtmlEmbed } from '@ckeditor/ckeditor5-html-embed';
import TextUppercase from './plugins/TextUppercase';
import FileUpload from './plugins/FileUpload';
// import sanitizeHtml from 'sanitize-html';


export default {
    mixins: [
    ],
    components: {
        // Use the <ckeditor> component in this view.
        ckeditor: CKEDITOR.component,
    },
    data() {
        return {
            toolbarType: CkEditor.Toolbar.Normal,
            toolbars: {
                basic: [
                    'undo',
                    'redo',
                    '|',
                    'heading',
                    '|',
                    'bold',
                    'italic',
                    'underline',
                    '|',
                    'alignment',
                    '|',
                    'bulletedList',
                    'numberedList',
                    '|',
                    'indent',
                    'outdent',
                    '|',
                    'horizontalLine',
                    '|',
                    'link',
                ],
                normal: [
                    'undo', 'redo',
                    '|',
                    'heading',
                    '|',
                    'fontSize', 'fontFamily',
                    {
                        label: 'Font color',
                        icon: 'plus',
                        items: [ 'fontColor', 'fontBackgroundColor' ]
                    },
                    '|',
                    'bold', 'italic', 'underline',
                    {
                        label: 'Formatting',
                        icon: 'text',
                        items: [ 'strikethrough', 'subscript', 'superscript', 'code', 'textUppercase', 'horizontalLine', '|', 'removeFormat' ]
                    },
                    '|',
                    'link', 'insertImage', 'insertTable',
                    {
                        label: 'Insert',
                        icon: 'plus',
                        items: [ 'highlight', 'blockQuote', 'mediaEmbed', 'codeBlock']
                    },
                    '|',
                    'alignment',
                    '|',
                    'bulletedList',	'numberedList',	'todoList', 'outdent', 'indent',
                ],
                complete: [
                    // 'undo', 'redo',
                    // '|', 'heading',
                    // '|', 'fontSize', 'fontColor', 'fontBackgroundColor', 'highlight',
                    // '|', 'bold', 'italic', 'strikethrough', 'underline', 'code', 'subscript', 'superscript',
                    // '|', 'alignment',
                    // '|', 'bulletedList', 'numberedList', 'todoList',
                    // '|', 'indent', 'outdent',
                    // '|', 'blockQuote', 'specialCharacters', 'horizontalLine', 'insertTable',
                    // '|', 'removeFormat','link', 'insertImage', 'mediaEmbed', 'htmlEmbed', 'sourceEditing'

                    'undo', 'redo',
                    // '|',
                    // 'exportPdf', 'exportWord', 'importWord',
                    // '|',
                    // 'showBlocks', 'formatPainter', 'findAndReplace', 'selectAll', 'wproofreader',
                    '|',
                    'heading',
                    // '|',
                    // 'style',
                    '|',
                    'fontSize', 'fontFamily',
                    {
                        label: 'Font color',
                        icon: 'plus',
                        items: [ 'fontColor', 'fontBackgroundColor' ]
                    },
                    '|',
                    // 'caseChange',
                    // '-',
                    'bold', 'italic', 'underline',
                    {
                        label: 'Formatting',
                        icon: 'text',
                        items: [ 'strikethrough', 'subscript', 'superscript', 'code', 'textUppercase', 'horizontalLine', '|', 'removeFormat' ]
                    },
                    'specialCharacters', 'pageBreak',
                    '|',
                    'link', 'insertImage', 'uploadFile', 'insertTable', 'tableOfContents', 'insertTemplate',
                    {
                        label: 'Insert',
                        icon: 'plus',
                        items: [ 'highlight', 'blockQuote', 'mediaEmbed', 'codeBlock', 'htmlEmbed' ]
                    },
                    '|',
                    'alignment',
                    '|',
                    'bulletedList',	'numberedList',	'todoList', 'outdent', 'indent',
                    '|',
                    'sourceEditing'
                ],
            },
        }
    },
    computed: {
        ckeditorConfig() {
            return this.$store.getters.ckeditorConfig || {};
        },
        language() {
            return this.ckeditorConfig.language ?? 'pt';
        },
        imageTypes() {
            return this.ckeditorConfig?.image?.types ?? [];
        },
        fileTypes() {
            let panelCfg = this.panel ?? {};
            return panelCfg?.file?.types ?? this.ckeditorConfig.file?.types ?? ['*'];
        },
        uploadUrl() {
            return this.getFormatUrlAPI(this.url?.quickUpload ?? this.ckeditorConfig?.url?.quickUpload ?? null);
        },
        withCredentials() {
            return !!this.$auth.user();
        },
        authorizationHeader() {
            return this.withCredentials ? `Bearer ${this.$auth.token()}` : ''
        },
        toolbar() {
            return this.toolbars[this.toolbarType] || [];
        },
        cKEditor() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    // isReadOnly: true,
                    language: this.language,
                    defaultLanguage: this.language,
                    plugins: this.plugins,
                    toolbar: {
                        items: this.toolbar,
                        shouldNotGroupWhenFull: true
                    },
                    table: {
                        contentToolbar: [
                            'tableColumn',
                            'tableRow',
                            'mergeTableCells',
                            'tableProperties',
                            'tableCellProperties'
                        ],
                        tableProperties: {
                            // The configuration of the TableProperties plugin.
                            // ...
                        },

                        tableCellProperties: {
                            // The configuration of the TableCellProperties plugin.
                            // defaultProperties: {
                            //     horizontalAlignment: 'left',
                            //     verticalAlignment: 'center',
                            //     padding: '2px'
                            // }
                        }
                    },
                    image: {
                        styles: [
                            'alignCenter',
                            'alignLeft',
                            'alignRight'
                        ],
                        // resizeUnit: 'px', //Defaults to '%'
                        resizeOptions: [
                            {
                                name: 'resizeImage:original',
                                label: 'Original',
                                value: null
                            },
                            {
                                name: 'resizeImage:50',
                                label: '50%',
                                value: '50'
                            },
                            {
                                name: 'resizeImage:75',
                                label: '75%',
                                value: '75'
                            },
                            {
                                name: 'resizeImage:custom',
                                label: 'Custom',
                                value: 'custom'
                            },
                        ],
                        toolbar: [
                            'imageTextAlternative', 'toggleImageCaption', '|',
                            'imageStyle:inline', 'imageStyle:wrapText', 'imageStyle:breakText', '|',
                            'resizeImage', '|', 'ckboxImageEdit', '|', 'linkImage'
                        ],
                        insert: {
                            integrations: [ 'upload', 'assetManager', 'url' ],
                            // If this setting is omitted, the editor defaults to 'block'.
                            // See explanation below.
                            type: 'auto'
                        },
                        upload: {
                            types: this.imageTypes
                        },
                        // resizeUnit: 'px', //Defaults to '%'
                        // resizeOptions: [
                        //     {
                        //         name: 'resizeImage:original',
                        //         label: 'Original',
                        //         value: null
                        //     },
                        //     {
                        //         name: 'resizeImage:50',
                        //         label: '50px',
                        //         value: '50'
                        //     },
                        //     {
                        //         name: 'resizeImage:100',
                        //         label: '100px',
                        //         value: '100'
                        //     },
                        //     {
                        //         name: 'resizeImage:200',
                        //         label: '200px',
                        //         value: '200'
                        //     },
                        //     {
                        //         name: 'resizeImage:250',
                        //         label: '250px',
                        //         value: '250'
                        //     },
                        //     {
                        //         name: 'resizeImage:300',
                        //         label: '300px',
                        //         value: '300'
                        //     },
                        //     {
                        //         name: 'resizeImage:400',
                        //         label: '400px',
                        //         value: '400'
                        //     }
                        // ]
                    },
                    list: {
                        properties: {
                            styles: true,
                            startIndex: true,
                            reversed: true
                        }
                    },
                    fileupload: {
                        upload: {
                            types: this.fileTypes
                        }
                    },
                    simpleUpload: {
                        // The URL that the images are uploaded to.
                        uploadUrl: this.uploadUrl,
                        // Enable the XMLHttpRequest.withCredentials property.
                        withCredentials: this.withCredentials,
                        // Headers sent along with the XMLHttpRequest to the upload server.
                        headers: {
                            // 'X-CSRF-TOKEN': 'CSRF-Token',
                            Authorization: this.authorizationHeader
                        }
                    },
                    // heading: {
                    //     options: [
                    //         { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
                    //         { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
                    //         { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
                    //         { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
                    //         { model: 'heading4', view: 'h4', title: 'Heading 4', class: 'ck-heading_heading4' },
                    //         { model: 'heading5', view: 'h5', title: 'Heading 5', class: 'ck-heading_heading5' },
                    //         { model: 'heading6', view: 'h6', title: 'Heading 6', class: 'ck-heading_heading6' }
                    //     ]
                    // },
                    fontSize: {
                        options: [
                            'tiny',
                            'small',
                            'default',
                            'big',
                            'huge'
                        ]
                    },
                    // Be careful with the setting below. It instructs CKEditor to accept ALL HTML markup.
                    // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#enabling-all-html-features
                    htmlSupport: {
                        allow: [
                            {
                                name: /.*/,
                                attributes: true,
                                classes: true,
                                styles: true,
                            }
                        ],
                        disallow: [ /* HTML features to disallow. */ ]
                    },
                    // Be careful with enabling previews
                    // https://ckeditor.com/docs/ckeditor5/latest/features/html-embed.html#content-previews
                    htmlEmbed: {
                        showPreviews: true,
                        sanitizeHtml: ( inputHtml ) => {
                            // Strip unsafe elements and attributes, for example:
                            // the `<script>` elements and `on*` attributes.
                            const outputHtml = inputHtml;//sanitizeHtml( inputHtml );
                            // const clean = sanitizeHtml(dirty, {
                            //     allowedTags: sanitizeHtml.defaults.allowedTags.concat([ 'img' ])
                            //   });
                            return {
                                html: outputHtml,
                                // true or false depending on whether the sanitizer stripped anything.
                                hasChanged: true
                            };
                        }
                    },
                    mediaEmbed: {
                        previewsInData: true
                    },
                    // https://ckeditor.com/docs/ckeditor5/latest/features/link.html#custom-link-attributes-decorators
                    link: {
                        addTargetToExternalLinks: true
                    },
                    removePlugins: [
                        // These two are commercial, but you can try them out without registering to a trial.
                        // 'ExportPdf',
                        // 'ExportWord',
                        'AIAssistant',
                        'CKBox',
                        'CKFinder',
                        'EasyImage',
                        // This sample uses the Base64UploadAdapter to handle image uploads as it requires no configuration.
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/base64-upload-adapter.html
                        // Storing images as Base64 is usually a very bad idea.
                        // Replace it on production website with other solutions:
                        // https://ckeditor.com/docs/ckeditor5/latest/features/images/image-upload/image-upload.html
                        // 'Base64UploadAdapter',
                        'MultiLevelList',
                        'RealTimeCollaborativeComments',
                        'RealTimeCollaborativeTrackChanges',
                        'RealTimeCollaborativeRevisionHistory',
                        'PresenceList',
                        'Comments',
                        'TrackChanges',
                        'TrackChangesData',
                        'RevisionHistory',
                        'Pagination',
                        'WProofreader',
                        // Careful, with the Mathtype plugin CKEditor will not load when loading this sample
                        // from a local file system (file://) - load this site via HTTP server if you enable MathType.
                        'MathType',
                        // The following features are part of the Productivity Pack and require additional license.
                        'SlashCommand',
                        'Template',
                        'DocumentOutline',
                        'FormatPainter',
                        'TableOfContents',
                        'PasteFromOfficeEnhanced',
                        'CaseChange',
                        'CloudServices',
                        'CloudServicesUploadAdapter',
                        'FindAndReplace',
                    ],
                },
            }
        },
        plugins() {
            let plugins = [
                Alignment,  // Adding the package to the list of plugins.
                BlockQuote,
                Bold, Italic, Underline, Strikethrough, Code, Subscript, Superscript,
                TextUppercase,
                Essentials,
                Heading,
                Font,
                Highlight,
                Image, ImageToolbar, ImageCaption, ImageStyle, ImageResize, ImageUpload, ImageInsert,
                Indent,
                Link, LinkImage,
                List, AutoLink,
                HorizontalLine,
                MediaEmbed,
                // Paragraph,
                Table, TableProperties, TableCellProperties, TableColumnResize, TableUtils, TableClipboard, TableSelection, TableToolbar,
                TextTransformation,
                RemoveFormat,
                SimpleUploadAdapter,
            ];

            if(this.toolbarType == CkEditor.Toolbar.Complete) {
                plugins = plugins.concat([
                    Autoformat,
                    AutoImage,
                    PictureEditing,
                    FileUpload,
                    PasteFromOffice,
                    GeneralHtmlSupport,
                    SourceEditing,
                    SpecialCharacters,
                    SpecialCharactersEssentials,
                    HtmlEmbed,
                ]);
            }
            return plugins;
        }
    },
    methods: {
    },
};
